// extracted by mini-css-extract-plugin
module.exports = {"personal-data__link":"_1DNcI","personal-data":"_2nYHn"};